import React from "react";
import Booking1 from "../assets/booking_1.png";
import Booking2 from "../assets/booking_2.png";

function Bookking() {
  return (
    <div className="container my-5 text-center">
      <h3 className="fw-bold">Thaani - Smart Booking Soultions</h3>
      <p className="text-warning fs-5">
        We provide smart booking solutions for fast and easy scheduling
      </p>

      <div className="row">
        <div className="col-lg-6 col-md-12">
          <img
            src={Booking1}
            alt="booking"
            className="mb-3"
            style={{ width: "100%" }}
          />
        </div>
        <div className="col-lg-6 col-md-12">
          <div className="row">
            <div className="title mt-5 text-start">
              <h4>🚖 App Booking</h4>
              <p>
                Book your ride instantly through our mobile app. Track your
                driver, choose your vehicle, and pay securely—all in one place.
              </p>
            </div>

            <div className="title mt-5 text-start">
              <h4>✍️ Manual Booking </h4>
              <p>
                Prefer the personal touch? Call us directly and our team will
                book your ride quickly and efficiently.
              </p>
            </div>

            <div className="title mt-5 text-start">
              <h4>💬 WhatsApp Booking</h4>
              <p>
                Just type “Auto or Taxi “ on Whatsapp In seconds, you'll be
                asked for your location. Enter pickup and drop points, and your
                ride will be auto-assigned.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-6 col-md-12">
          <div className="row">
            <div className="title mt-5 text-start">
              <h4>🖥️ Kiosk Booking </h4>
              <p>
                Book a ride in seconds using our easy-to-use self-service kiosks
                available at hotels, airports, and key city points.
              </p>
            </div>

            <div className="title mt-5 text-start">
              <h4>🏢 Corporate Booking </h4>
              <p>
                We offer reliable, punctual, and professional transport
                solutions for your business. Manage your rides, get monthly
                billing, and enjoy priority service.
              </p>
            </div>

            <div className="title mt-5 text-start">
              <h4>🏢 Web Booking</h4>
              <p>
                Book your ride directly from our website in just a few clicks.
                Enter your pickup and drop-off locations, choose your vehicle,
                and get instant confirmation—anytime, anywhere.
              </p>
            </div>
          </div>
        </div>
        <div className="col-lg-6 col-md-12">
          <img
            src={Booking2}
            alt="booking"
            className="mb-3"
            style={{ width: "100%" }}
          />
        </div>
      </div>
    </div>
  );
}

export default Bookking;
